<template>
  <div id="customer-digital-proposal">
    <nav class="navbar has-background-white-bis has-shadow" 
      role="navigation" 
      aria-label="main navigation">
      <div class="navbar-brand">
        <a class="navbar-item px-2 py-1">
          <img src="@/assets/mitrex_and_cladify_logo.png" width="150">
        </a>

        <a 
          role="button" 
          class="navbar-burger burger" 
          :class="{ 'is-active': active }"
          aria-label="menu" 
          aria-expanded="false"
          @click="active = !active">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div class="navbar-menu">
        <div class="navbar-start">
          <a class="navbar-item" 
            @click="activePage = 'drawings'"
            :class="{ 'is-active': activePage == 'drawings' }">
            Project Drawings
          </a>

          <a class="navbar-item" 
            @click="activePage = 'pricing'"
            :class="{ 'is-active': activePage == 'pricing' }">
            Project Pricing
          </a>

          <a class="navbar-item" 
            @click="activePage = 'tos'"
            :class="{ 'is-active': activePage == 'tos' }">
            General Terms of Sale
          </a>
        </div>

        <v-fade-transition mode="out-in">
          <div class="navbar-end" v-if="activePage == 'pricing' && 
            rfq && rfq.product_brand == 'Mitrex'">
            <div class="navbar-item">
              <div class="buttons has-addons">
                <button class="button is-rounded"
                  :class="{ 'is-orange': pricingType == 'mpa' }"
                  @click="pricingType = 'mpa'">
                  MPA Pricing
                </button>
                <button class="button is-rounded"
                  :class="{ 'is-orange': pricingType == 'dpa' }"
                  @click="pricingType = 'dpa'">
                  DPA Pricing
                </button>
              </div>
            </div>
          </div>
        </v-fade-transition>
      
      </div>
    </nav>

    <div 
      id="drawing-preview" 
      v-show="activePage == 'drawings'"
      v-if="rfq">

      <div 
        id="estimation-details" 
        class="columns mx-0 my-0 estimation-details"
        :style="estimationDetailsStyle">
        <div class="column px-0 py-0">
          <div class="has-background-white-bis 
            flex flex--row flex--align-center flex--justify-space-between">

            <div class="card-content project-name has-text-weight-bold"
              :style="projectNameStyle">
              <span>
                {{ rfq.project.project_name }}
              </span>
            </div>

            <div class="navbar-end" v-if="rfq && rfq.product_brand == 'Mitrex'">
              <div class="navbar-item">
                <div class="buttons has-addons">
                  <button class="button is-rounded"
                    :class="{ 'is-orange': pricingType == 'mpa' }"
                    @click="pricingType = 'mpa'">
                    MPA Pricing
                  </button>
                  <button class="button is-rounded"
                    :class="{ 'is-orange': pricingType == 'dpa' }"
                    @click="pricingType = 'dpa'">
                    DPA Pricing
                  </button>
                </div>
              </div>
            </div>

            <!-- <v-fade-transition mode="out-in" :duration="500">
              <div class="flex flex--row" v-if="scrollPos >= 100">
                <div class="card-content py-2">
                  <div class="has-text-weight-bold is-size-6 has-text-grey">
                    {{ totalArea | commasep(0) }}
                  </div>
                  <div class="is-size-7">
                    total sqft
                  </div>
                </div>
                <div class="card-content py-2">
                  <div class="has-text-weight-bold is-size-6 has-text-grey">
                    {{ totalLf | commasep(0) }}
                  </div>
                  <div class="is-size-7">
                    total lf
                  </div>
                </div>
                <div class="card-content py-2">
                  <div class="has-text-weight-bold is-size-6 has-text-grey">
                    {{ totalPrice | currency(0) }}
                  </div>
                  <div class="is-size-7">
                    total price (+tax)
                  </div>
                </div>
                <div v-if="rfq.product_brand == 'Mitrex'" class="card-content py-2">
                  <div class="has-text-weight-bold is-size-6 has-text-grey">
                    {{ systemSize | commasep(0) }}
                  </div>
                  <div class="is-size-7">
                    system size (kW)
                  </div>
                </div>
                <div v-if="rfq.product_brand == 'Mitrex'" class="card-content py-2">
                  <div class="has-text-weight-bold is-size-6 has-text-grey">
                    {{ elecProceeds | currency(0) }}
                  </div>
                  <div class="is-size-7">
                    approx. energy revenue (30 yrs)
                  </div>
                </div>
              </div>
            </v-fade-transition> -->
            
          </div>

          <hr class="my-0" v-if="scrollPos < 40">

          <div 
            class="has-background-white-bis estimation-details__numbers"
            :style="estimationNumbersStyle">

            <div class="flex flex--row flex--wrap flex--nogrow">
              <div 
                v-for="(item, i) in rfq.c_estimation.items" 
                :key="item.id"
                class="card-content"
                :class="{ 'pr-2': i + 1 != rfq.c_estimation.items }">

                <div class="dropdown is-hoverable">
                  <div 
                    class="dropdown-trigger"
                    aria-haspopup="true" 
                    aria-controls="dropdown-menu4">
                    <div class="has-text-weight-bold has-text-grey 
                      flex flex--row flex--align-center mb-2">
                      <div 
                        class="highlight-sample-dot" 
                        :style="{ background: item.color }">
                      </div>
                      <div>
                        {{ item.architecture_name }}
                      </div>
                    </div>
                    <div 
                      class="has-text-grey highlight-material-details">
                      <span class="has-text-weight-bold">
                        {{ item[itemTypeMeasure[item.type]] | commasep(0) }}
                      </span>
                      <span class="is-size-7">
                        {{ itemTypeMeasureLabel[item.type] | uppercase }}
                      </span>
                    </div>
                    <div 
                      class="has-text-weight-bold has-text-grey highlight-material-details">
                      {{ item[itemPricingField] | currency(0) }}
                    </div>
                    <div 
                      v-if="rfq.product_brand == 'Mitrex'"
                      class="has-text-grey highlight-material-details">
                      <span class="has-text-weight-bold">
                        {{ item.system_size | commasep(0) }}
                      </span>
                      <span class="is-size-7">kW</span>
                    </div>
                    <div 
                      v-if="rfq.product_brand == 'Mitrex'"
                      class="has-text-grey highlight-material-details">
                      <span class="has-text-weight-bold">
                        {{ item[itemElecProceedsField] | currency(0) }}
                      </span>
                      <span class="is-size-7">revenue</span>
                    </div>
                  </div>

                  <div class="dropdown-menu" id="dropdown-menu4" role="menu">
                    <div class="dropdown-content">
                      <div class="dropdown-item">
                        <div 
                          v-if="item.facing_image" 
                          style="border-radius: 6px; height: 70px; width: 70px;">
                          <img 
                            style="object-fit: contain"
                            :src="item.facing_image"
                            :alt="item.facing_name"/>
                        </div>
                        <div class="is-size-7 mt-1">{{item.facing_name}}</div>
                      </div>
                    </div>
                  </div>
                </div>
          
              </div>
            </div>

            <div class="card-content pt-0 is-size-7 is-italic">
              Note: The total price for each material includes the fabricated area, 
              which is not reflected in the drawing highlights.
            </div>

            <!-- <div class="card-content mr-2">

              <div class="columns">
                <div class="text--nowrap column">
                  <div class="title is-4 mb-1 has-text-grey">
                    {{ totalArea | commasep(0) }}
                  </div>
                  <div class="is-size-7">
                    TOTAL SQFT
                  </div>
                </div>

                <div v-if="hasRailing" class="text--nowrap column">
                  <div class="title is-4 mb-1 has-text-grey">
                    {{ totalLf | commasep(0) }}
                  </div>
                  <div class="is-size-7">
                    TOTAL LF
                  </div>
                </div>

                <div class="text--nowrap column">
                  <div class="title is-4 mb-1 has-text-grey">
                    {{ totalPrice | currency(0) }}
                  </div>
                  <div class="is-size-7">
                    TOTAL PRICE (+tax)
                  </div>
                </div>
              </div>
              
              <div 
                class="columns"
                v-if="rfq.product_brand == 'Mitrex'">
                <div 
                  class="text--nowrap column pb-0">
                  <div class="title is-4 mb-1 has-text-grey">
                    {{ systemSize | commasep(0) }}
                  </div>
                  <div class="is-size-7">
                    SYSTEM SIZE (kW)
                  </div>
                </div>

                <div
                  class="text--nowrap column pb-0">
                  <div class="title is-4 mb-1 has-text-grey">
                    {{ elecProceeds | currency(0) }}
                  </div>
                  <div class="is-size-7">
                    30-YR APPROX REV.
                  </div>
                </div>
              </div>
            </div> -->

          </div>

        </div>
      </div>

      <div class="is-fullwidth"
        :style="estimationHighlightsStyle">
        <div class="drawing__tooltip">
        </div>
        <img 
          id="svg-preview"
          class="inject-me" 
          :src="rfq.drawing_highlights[0].drawing_svg"/>
      </div> 
    </div>

    <div
      v-show="activePage == 'pricing'" 
      v-if="rfq"
      class="container py-5">

      <div class="columns flex--justify-center">
        <div class="column is-two-thirds-widescreen is-three-quarters-desktop 
          is-four-fifths-tablet is-full-mobile">
          <proposal-preview-mitrex 
            v-if="rfq.product_brand == 'Mitrex'"
            :estimation="rfq.c_estimation"
            :pricing-type="pricingType"
            :has-tax-incentives="false"/>
          
          <proposal-preview-cladify 
            v-else
            :estimation="rfq.c_estimation"/>

          <hr/>

          <general-information 
          :proposal="proposal" 
          :has-signature-line="false"/>
        </div>
      </div>

    </div>

    <div
      v-show="activePage == 'tos'" 
      v-if="rfq"
      class="container py-5">

      <div class="columns flex--justify-center">
        <div class="column is-two-thirds-widescreen is-three-quarters-desktop 
          is-four-fifths-tablet is-full-mobile">
          <general-terms-of-sale 
            :product-brand="rfq.product_brand"
            :has-signature-line="false"
            :fit-page="false"/>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import SVGInjector from 'svg-injector'
import VFadeTransition from '@/components/transitions/VFadeTransition'
import ProposalPreviewMitrex from '@/components/proposalmaker/ProposalPreviewMitrex'
import ProposalPreviewCladify from '@/components/proposalmaker/ProposalPreviewCladify'
import GeneralInformation from '@/components/proposalmaker/GeneralInformation'
import GeneralTermsOfSale from '@/components/proposalmaker/GeneralTermsOfSale'

import filters from '@/filters'

export default {
  components: { 
    ProposalPreviewMitrex, ProposalPreviewCladify, GeneralInformation, 
    GeneralTermsOfSale, VFadeTransition
  },
  data() {
    return {
      id: 'test-psd',
      rfq: null,
      proposal: null,
      scrollPos: 0,
      estimationDetailsHeight: 212.4,
      pricingType: 'mpa',
      activePage: 'drawings',
      active: false,
      tooltip: null,
      itemTypeMeasure: {
        'wall': 'total_area_sqft',
        'unknown': 'total_area_sqft',
        'railing': 'total_linear_ft'
      },
      itemTypeMeasureLabel: {
        'wall': 'sqft',
        'unknown': 'sqft',
        'railing': 'lf'
      }
    }
  },
  computed: {
    hasRailing({ rfq }) {
      return rfq.product_brand == 'Mitrex' && 
        Object.keys(rfq.c_estimation.estimation_summary)
          .includes('solar_railing_1100_1400')
    },
    totalArea({ rfq }) {
      return rfq.product_brand == 'Cladify' ? rfq.c_estimation.total_area_sqft :
        rfq.c_estimation.estimation_summary.summary
          .filter(d => d.pricing_summary.includes('wall') || 
            d.pricing_summary.includes('cladding'))
          .map(d => d.measure).reduce((a,b) => +a + +b, 0) 
    },
    totalLf({ rfq }) {
      return rfq.c_estimation.estimation_summary.solar_railing_1100_1400
        .map(d => d.sum_linear_ft).reduce((a,b) => +a + +b, 0)
    },
    estimationSummary({ rfq, pricingType }) {
      return pricingType == 'mpa' ? rfq.c_estimation.estimation_summary :
        rfq.c_estimation.estimation_summary_dpa
    },
    totalPrice({ rfq, estimationSummary }) {
      return rfq.product_brand == 'Mitrex' ? estimationSummary.summary.map(
        d => d.price).reduce((a,b) => +a + +b, 0) : 
        rfq.c_estimation.total_price_pre_tax;
    },
    systemSize({ estimationSummary }) {
      return estimationSummary.summary
                .filter(d => !d.pricing_summary.includes('batteries'))
                .map(d => d.system_size)
                .reduce((a,b) => +a + +b, 0);
    },
    elecProceeds({ estimationSummary }) {
      return estimationSummary.summary.map(
        d => d.elec_proceeds_for_business).reduce((a,b) => +a + +b, 0);
    },
    itemPricingField({ rfq, pricingType }) {
      return rfq.product_brand == 'Cladify' ? 'total_price' :
        pricingType == 'mpa' ? 'total_price_mpa' : 'total_price_dpa';
    },
    itemElecProceedsField({ pricingType }) {
      return pricingType == 'mpa' ? 'elec_proceeds_mpa' : 'elec_proceeds_dpa';
    },
    projectNameStyle({ scrollPos }) {
      const maxFont = 2,
            minFont = 1,
            maxPad = 1.5,
            minPad = 0.5;

      if (scrollPos < 20) {
        return { "font-size": `${maxFont}rem` }
      } else {
        const padding = Math.max(minPad, maxPad - scrollPos / 100);
        return { 
          "font-size": `${Math.max(minFont, maxFont - scrollPos / 100)}rem`,
          "padding-top": `${padding}rem`,
          "padding-bottom": `${padding}rem`
        }
      }
    },
    estimationDetailsStyle({ scrollPos }) {
      return { "top": `${Math.max(0, 52 - scrollPos)}px` }
    },
    estimationNumbersStyle({ scrollPos }) {
      if (scrollPos < 10) {
        return { "max-height": "200px" }
      } else {
        return { 
          "max-height": `${Math.max(0, 200 - scrollPos)}px`,
          "overflow": "hidden"
        }
      }
    },
    estimationHighlightsStyle({ estimationDetailsHeight }) {
      return { "margin-top": `${estimationDetailsHeight}px`}
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$http.estimationPreview.get(this.$route.params.apiToken).then(resp => {
        this.rfq = this.processRfq(resp.data.rfq);
        this.proposal = resp.data.proposal;

        this.$nextTick(() => {
          let image = document.querySelector('#svg-preview');
          image.onload = () => {
            this.buildSVG();	
          };
          this.getEstimationDetailsHeight();
        })
      }).catch(() => {
        this.$router.push({ name: 'LinkExpired' });
      });
      this.scrollListen();
    },
    processRfq(rfq) {
      if (rfq.product_brand == 'Cladify') {
        rfq.c_estimation.items.forEach(item => {
          let facing = item.materials
            .filter(d => d.product_master.product_category_id == 13)[0]
          
          if (facing) {
            item.total_area_sqft = facing.area;
            item.facing_image = facing.product_master.image;
            item.facing_name = facing.product_master.name;
            item.type = 'wall';
          } else {
            item.facing_image = null;
            item.facing_name = null;
            item.type = 'unknown';
          }
        })

        return rfq
      } else {
        let mpaSummary = rfq.c_estimation.estimation_summary,
            dpaSummary = rfq.c_estimation.estimation_summary_dpa;

        let facingProductIds = mpaSummary.price_by_material_cladding
                                  .map(d => d.product_master_id);

        rfq.c_estimation.items.forEach(item => {
          const facing = item.materials
                  .filter(d => facingProductIds.includes(d.product_master_id))[0],
                itemMaterialCategories = item.materials
                  .map(d => d.product_master.product_category_id);
          
          if (facing) {
            item.type = itemMaterialCategories.includes(13) ?
              'wall' : itemMaterialCategories.includes(20) ? 'railing' : 'unknown';
            const summaryField = item.type == 'railing' ? 'solar_railing_1100_1400' : 
              'solar_wall_active';
            item.total_area_sqft = item.elevations.map(d => d.area).reduce((a,b) => +a + +b, 0);
            item.facing_image = facing.product_master.image;
            item.facing_name = facing.product_master.name;
            item.total_price_mpa = mpaSummary.price_by_material_cladding.filter(
              d => d.product_master_id == facing.product_master_id)[0].total_cost;
            item.total_price_dpa = dpaSummary.price_by_material_cladding.filter(
              d => d.product_master_id == facing.product_master_id)[0].total_cost;
            item.system_size = mpaSummary[summaryField]
              .filter(d => d.product_master_id == facing.product_master_id)
              .map(d => d.system_capacity)
              .reduce((a,b) => +a + +b, 0);
            item.elec_proceeds_mpa = mpaSummary[summaryField]
              .filter(d => d.product_master_id == facing.product_master_id)
              .map(d => d.elec_proceeds_for_business)
              .reduce((a,b) => +a + +b, 0);
            item.elec_proceeds_dpa = dpaSummary[summaryField]
              .filter(d => d.product_master_id == facing.product_master_id)
              .map(d => d.elec_proceeds_for_business)
              .reduce((a,b) => +a + +b, 0);
          }
        })

        return rfq
      }
    },
    getTooltipHtml(item, fill) {
      let image = item.facing_image ? `<div style="border-radius: 6px; 
                                        height: 50px; 
                                        width: 50px;">
                                          <img 
                                            style="object-fit: contain"
                                            src=${item.facing_image} 
                                            alt=${item.facing_name}/>
                                        </div>` : '';
      let mitrexInfo = this.rfq.product_brand == 'Mitrex' ? 
                          `<div class="column is-half py-1">
                              <div class="is-size-5 has-text-weight-bold">
                                ${filters.CommaSep(item.system_size, 0)}
                              </div>
                              <div class="is-size-7">System Size (kW)</div>
                            </div>
                            <div class="column is-half py-1">
                              <div class="is-size-5 has-text-weight-bold">
                                ${filters.Currency(item[this.itemElecProceedsField], 0)}
                              </div>
                              <div class="is-size-7">30-yr Energy Rev.</div>
                            </div>` : '';

      return `<div class="is-size-5 has-text-weight-bold mb-2" 
                style="display: flex; flex-direction: row; align-items: center">
                <div 
                  style="border-radius: 50%; 
                        height: 15px; 
                        width: 15px; 
                        margin-right: 5px; 
                        background: ${fill}">
                </div>
                <div>${item.architecture_name}</div>
              </div>
              <div class="mb-2">
                ${image}
                <div class="is-size-7 mt-1">${item.facing_name}</div>
              </div>
              <hr class="my-4"/>
              <div class="columns is-multiline">
                <div class="column is-half py-1">
                  <div class="is-size-5 has-text-weight-bold">
                    ${filters.CommaSep(item[this.itemTypeMeasure[item.type]], 0)}
                  </div>
                  <div class="is-size-7">
                    Total ${filters.Uppercase(this.itemTypeMeasureLabel[item.type])}
                  </div>
                </div>
                <div class="column is-half py-1">
                  <div class="is-size-5 has-text-weight-bold">
                    ${filters.Currency(item[this.itemPricingField], 0)}
                  </div>
                  <div class="is-size-7">Total Price</div>
                </div>
                ${mitrexInfo}
              </div>`
    },
    showTooltip(evt, svg, item) {

      const width = window.innerWidth,
            height = window.innerHeight,
            scrollY = window.scrollY,
            scrollX = window.scrollX,
            eventX = evt.pageX,
            eventY = evt.pageY;

      const rect = svg.getBoundingClientRect();
      const left = rect.left + scrollX,
            top = rect.top + scrollY;
      
      if (eventX < (width / 2)) {
        this.tooltip.style.right = ""
        this.tooltip.style.left = (eventX - left + 10) + "px";
      } else {
        this.tooltip.style.left = ""
        this.tooltip.style.right = (width - eventX - 10) + "px";
      }

      if ((eventY - scrollY) < (height / 2)) {
        this.tooltip.style.bottom = ""
        this.tooltip.style.top = (eventY) + "px";
      } else {
        this.tooltip.style.top = ""
        this.tooltip.style.bottom = (height - eventY) + "px";
      }

      this.tooltip.style.visibility = "visible";
      let fill = evt.target.getAttribute("data-tooltip-dot-fill");
      this.tooltip.innerHTML = this.getTooltipHtml(item, fill);
    },
    hideTooltip() {
      this.tooltip.style.visibility = "hidden";
    },
    buildSVG() {
      const { rfq } = this;
      let vm = this;

      this.tooltip = document.querySelector('.drawing__tooltip');

      var mySVGsToInject = document.querySelectorAll('img.inject-me');
      SVGInjector(mySVGsToInject, {
        each: function(svg) {
          let children = svg.children;

          // Set width to 100%;
          svg.setAttribute("width", "100%");
          svg.setAttribute("height", "auto");

          for (var i = 0; i < children.length; i++) {
            if (children[i].nodeName == 'path') {
              let itemIndex = rfq.c_estimation.items.map(
                d => d.architecture_name).indexOf(children[i].id)

              if (itemIndex == -1) {
                itemIndex = rfq.c_estimation.items.map(
                  d => d.architecture_name).indexOf(children[i].id.replaceAll('_', ' '))
              }

              if (itemIndex != -1) {
                let item = rfq.c_estimation.items[itemIndex];

                children[i].addEventListener('mousemove', e => vm.showTooltip(e, svg, item));
                children[i].addEventListener('mouseout', vm.hideTooltip);
                var fill = window.getComputedStyle(children[i]).fill;
                children[i].setAttribute("data-tooltip-dot-fill", fill);
                // children[i].setAttribute("data-item", JSON.stringify(item));

                vm.$set(item, 'color', fill);
              }
            }
          }

          // Set hover styles;
          children.forEach(child => {
            if (child.nodeName == 'defs') {
              child.children.forEach(styleSheet => {
                if (styleSheet.nodeName == 'style') {
                  styleSheet.sheet.insertRule(
                    `path:hover, rect:hover { 
                      transition: opacity .4s ease-in-out; 
                      opacity: 0.5; 
                    }`, 
                    styleSheet.sheet.cssRules.length
                  );
                }
              })
            }
          })
        }
      });
    },
    scrollListen() {
      document.addEventListener('scroll', e => {
        this.scrollPos = window.scrollY;
      });
    },
    getEstimationDetailsHeight() {
      const el = document.querySelector('#estimation-details');
      if (el) {
        this.estimationDetailsHeight = el.clientHeight;
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/flexbox.scss";

.drawing__tooltip {
	position: absolute;
	max-width: 275px;
	height: auto;
	padding: 10px 15px;
	font-size: 12px;
	color: #0E4E74 !important;
	border-radius: 5px;
	border: 1px solid #E0E2E3;
	pointer-events: none;
	background: rgba(255, 255, 255, 0.95);
	z-index: 20000;
  visibility: hidden;
  transition: visibility 0.3s ease-in-out;
}

.architecture-name {
  font-size: 1em !important;
  font-weight: bold !important;
}

.text--primary {
  color: #0E4E74;
}

.text--nowrap {
  white-space: nowrap;
}

#drawing-preview {
  font-family: 'Montserrat', sans-serif;
}

.highlight-sample-dot {
  border-radius: 50%; 
  height: 15px; 
  width: 15px; 
  margin-right: 5px;
}

.highlight-material-details {
  font-size: 0.8em;
}

.project-name {
  transition: font-size 500ms ease-in-out;
}

.estimation-details {
  width: 100%;
  transition: position 500ms ease-in-out;
  position: fixed;
  z-index: 5;

  &__numbers {
    transition: max-height 500ms ease-in-out;
  }
}

.dropdown-menu {
  z-index: 10;
  min-width: 100px;
}

.is-orange {
  background: #F06733;
  color: #fff;
  &:hover, &:focus {
    color: #fff;
  }
}
</style>